<template>
  <div id="app">
    <Header/>
      <router-view>
      </router-view>
    <cookie-law 
      buttonText="Alles klar!"
    >
      <div slot="message">
        Diese Website verwendet Cookies. Mit der weiteren Nutzung der Website stimmen Sie der Verwendung von Cookies zu.
        <!-- <router-link to="datenschutz">Mehr Infos</router-link> -->
      </div>
    </cookie-law>
    <Footer/>
  </div>
</template>

<script>

import CookieLaw from 'vue-cookie-law'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    CookieLaw,
    Header,
    Footer
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/_buefy-customization.scss';
@import '@/assets/styles/global.scss';
</style>
